// LOCAL COMPONENTS
import Router from './parts/Router';
import Alert from './prototype/Alert';
import Dismissable from './types/Dismissable';
import Loading from './types/Loading';

// CHILD ASSIGNMENT
Alert.Dismissable = Dismissable;
Alert.Loading = Loading;
Alert.Router = Router;

// EXPORT
export default Alert;
